module.exports = __webpack_public_path__ + "img/Inactive-Managers.1d2d6905.png";